import { render, staticRenderFns } from "./ServiceDashboard.vue?vue&type=template&id=86ae4c60&scoped=true"
import script from "./ServiceDashboard.vue?vue&type=script&lang=js"
export * from "./ServiceDashboard.vue?vue&type=script&lang=js"
import style0 from "./ServiceDashboard.vue?vue&type=style&index=0&id=86ae4c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ae4c60",
  null
  
)

export default component.exports